import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BlogSidebar from "../BlogSidebar/BlogSidebar.js";
import client, { urlFor } from "../../sanity/sanityClient";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const BlogList = (props) => {
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "post"] | order(publishedAt desc) {
          _id,
          title,
          slug,
          mainImage,
          publishedAt,
          body, // Fetch the full body to preview content
          "authorName": author->name
        }`
      )
      .then((data) => {
        setBlogs(data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Sanity fetch error:", err);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) return <p>Loading blog posts...</p>;

  if (!blogs.length) return <p>No blog posts found.</p>;

  return (
    <section className="wpo-blog-pg-section section-padding">
      <div className="container">
        <div className="row">
          <div className={`col col-lg-8 col-12 ${props.blRight}`}>
            <div className="wpo-blog-content">
              {blogs.map((blog) => (
                <div className="post" key={blog._id}>
                  <div className="entry-media">
                    {blog.mainImage && (
                      <img
                        src={urlFor(blog.mainImage).width(600).url()}
                        alt={blog.title}
                      />
                    )}
                  </div>
                  <div className="entry-meta">
                    <ul>
                      <li>
                        <i className="fi flaticon-user"></i> By{" "}
                        <Link
                          onClick={ClickHandler}
                          to={`/blog-single/${blog.slug.current}`}
                        >
                          {blog.authorName}
                        </Link>
                      </li>
                      <li>
                        <i className="fi flaticon-calendar"></i>{" "}
                        {new Date(blog.publishedAt).toLocaleDateString()}
                      </li>
                    </ul>
                  </div>
                  <div className="entry-details">
                    <h3>
                      <Link
                        onClick={ClickHandler}
                        to={`/blog-single/${blog.slug.current}`}
                      >
                        {blog.title}
                      </Link>
                    </h3>
                    <p>
                      {blog.body
                        ? blog.body
                            .filter((block) => block._type === "block")
                            .map((block) =>
                              block.children
                                .map((child) => child.text)
                                .join(" ")
                            )
                            .join(" ")
                            .slice(0, 150) + "..."
                        : "No preview available."}
                    </p>
                    <Link
                      onClick={ClickHandler}
                      to={`/blog-single/${blog.slug.current}`}
                      className="read-more"
                    >
                      READ MORE...
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <BlogSidebar blLeft={props.blLeft} />
        </div>
      </div>
    </section>
  );
};

export default BlogList;
